export default function viewWebsiteStory({record}) {
    if (record.storyId) {
        return {
            name: "查看稿件", condition: ["已回稿"], onOk: () => {
                let activitiConfName = "activitiTreeRoot-appointment";//"activitiTreeRoot-appointment";
                window.openEditById({
                    params: {
                        activitiConfName,
                    },
                    configName: "webEditor",
                    id: record.storyId
                });
            }
        };
    }
}